import * as React from "react";
import { cn } from "@/lib/utils";

export type BadgeVariant = "default" | "secondary" | "outline" | "tertiary" | "muted" | "success" | "warning" | "danger";

const variantClasses: Record<BadgeVariant, string> = {
  default:
    "bg-emerald-500/10 text-emerald-700 border-emerald-500/20",
  secondary:
    "bg-white/95 text-slate-800 border-black/5 shadow-[0_2px_8px_rgba(0,0,0,0.04)] backdrop-blur-sm",
  outline:
    "border-black/5 bg-white/60 text-slate-600 shadow-sm",
  tertiary:
    "border-black/5 bg-white/60 text-slate-600 shadow-sm",
  muted:
    "border-transparent bg-slate-100/80 text-slate-600",
  success:
    "border-emerald-500/20 bg-emerald-50/90 text-emerald-700 shadow-sm",
  warning:
    "border-amber-500/20 bg-amber-50/90 text-amber-700 shadow-sm",
  danger:
    "border-rose-500/20 bg-rose-50/90 text-rose-700 shadow-sm",
};

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: BadgeVariant;
}

export function Badge({ variant = "default", className, ...props }: BadgeProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 rounded-sm border px-3 py-1 text-xs font-medium tracking-normal transition-colors",
        variantClasses[variant],
        className,
      )}
      {...props}
    />
  );
}
